import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";
const textareaVariants = cva("flex min-h-[80px] w-full rounded-lg border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50");
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
    return _jsx("textarea", { className: cn(textareaVariants(), className), ref: ref, ...props });
});
Textarea.displayName = "Textarea";
export { Textarea };
